import { useEffect, useRef } from 'react'
import { mainButtonState, notifyButtons } from './vk-bridge-adapter'

interface MainButtonOptions {
  text: string
  onClick: () => void
  color?: string
  textColor?: string
  isActive?: boolean
  isLoading?: boolean
}

export function useMainButton(options: MainButtonOptions | null) {
  const callbackRef = useRef<(() => void) | null>(null)

  useEffect(() => {
    const removeCallback = () => {
      if (!callbackRef.current) return
      const idx = mainButtonState.onClickCallbacks.indexOf(callbackRef.current)
      if (idx !== -1) mainButtonState.onClickCallbacks.splice(idx, 1)
      callbackRef.current = null
    }

    if (!options) {
      removeCallback()
      mainButtonState.isVisible = false
      mainButtonState.isProgressVisible = false
      notifyButtons()
      return () => {}
    }

    const { text, onClick, color, textColor, isActive = true, isLoading = false } = options

    removeCallback()

    const handleClick = () => { if (!isLoading) onClick() }
    callbackRef.current = handleClick
    mainButtonState.onClickCallbacks.push(handleClick)

    mainButtonState.text = text
    if (color) mainButtonState.color = color
    if (textColor) mainButtonState.textColor = textColor
    mainButtonState.isActive = isActive && !isLoading
    mainButtonState.isVisible = true
    mainButtonState.isProgressVisible = isLoading
    notifyButtons()

    return () => {
      removeCallback()
      mainButtonState.isVisible = false
      mainButtonState.isProgressVisible = false
      notifyButtons()
    }
  }, [
    options?.text,
    options?.onClick,
    options?.color,
    options?.textColor,
    options?.isActive,
    options?.isLoading,
  ])
}
